import React from 'react';
import { inputs } from '@ecosystem/newron-design-system';
import { Entity } from '../types';
import { FilterProps } from './types';

type Props = FilterProps & {
  label: string;
};

const { Checkbox, CheckboxState } = inputs;

function CheckboxFilter({ label, definition: { options, name }, values, disabled, onChange }: Props) {
  const handleChange = (option: Entity) => (state: inputs.CheckboxState) => {
    const entities =
      state === CheckboxState.CHECKED ? [...values, option] : values.filter(value => value.label !== option.label);
    onChange(name, entities);
  };

  const getState = (optionValue: string) => {
    return values.some(({ value }) => value === optionValue) ? CheckboxState.CHECKED : CheckboxState.UNCHECKED;
  };

  return (
    <>
      <div className="text-md font-bold flex-grow text-heading pb-2">{label}</div>
      {options.map(option => (
        <div key={option.label} className="py-2">
          <Checkbox
            disabled={disabled}
            label={option.label}
            state={getState(option.value)}
            onChange={handleChange(option)}
          />
        </div>
      ))}
    </>
  );
}

export { CheckboxFilter };
